export default __webpack_public_path__ + "static/media/shottracker-thumbnail.2edd5891.png";